










 

 

























const node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "RetroReflectionGroup",
  "kind": "LinkedField",
  "name": "spotlightGroup",
  "plural": false,
  "selections": [
    (v0/*: any*/)
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "spotlightSearchQuery",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isComplete",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "phaseType",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DraggableReflectionCard_meeting",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReflectionCard_meeting"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RemoteReflection_meeting"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useSpotlightResults_meeting",
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/)
          ]
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "phases",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "stages",
          "plural": true,
          "selections": (v3/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "localStage",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "spotlightReflectionId",
          "storageKey": null
        },
        (v2/*: any*/)
      ]
    }
  ],
  "type": "RetrospectiveMeeting",
  "abstractKey": null
};
})();

(node ).hash = "03bde1d5585023089927fdb3688f47ae";

export default node;
